(() => {
  const configNode = document.getElementById('by-wishlist-config')
  let config = {}
  try { config = JSON.parse(configNode?.textContent || '{}') } catch (_) {}
  const theme = window.MinimogSettings?.theme || {}
  const previewUrl = value => {
    const url = new URL(value, location.origin)
    if (url.origin === location.origin && String(theme.role).toLowerCase() !== 'main' && theme.id) url.searchParams.set('preview_theme_id', theme.id)
    return url.href
  }
  const keepPreviewLinks = () => {
    document.querySelectorAll('a[href*="/pages/wishlist"]').forEach(link => {
      if (link.origin === location.origin) link.href = previewUrl(link.href)
    })
  }
  let previousCount = -1
  const updateCounts = () => {
    const source = document.querySelector('[data-by-xb-count]')
    if (!source || !/^\d+$/.test(source.textContent.trim())) return
    const count = Number(source.textContent.trim())
    const badges = document.querySelectorAll('.m-wishlist-count')
    if (count === previousCount && Array.from(badges).every(badge => badge.textContent === String(count))) return
    previousCount = count
    badges.forEach(badge => {
      badge.textContent = String(count)
      badge.classList.toggle('m:hidden', count < 1)
    })
    document.body.classList.toggle('wishlist-has-item', count > 0)
  }
  window.MinimogTheme.Wishlist = {
    setWishlistButtonsState: updateCounts,
    updateWishlistCount: updateCounts,
    addEventToWishlistButtons: () => {},
    init: keepPreviewLinks
  }
  keepPreviewLinks()
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a.m-header__wishlist, a.by-mobile-wishlist__link')
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    event.stopImmediatePropagation()
    location.assign(previewUrl(link.href))
  }, true)
  const observer = new MutationObserver(() => { updateCounts(); keepPreviewLinks() })
  observer.observe(document.body, { childList: true, subtree: true, characterData: true })
  window.addEventListener('pageshow', updateCounts)

  const shareApi = 'https://bikiniyes-wishlist-links.woodsycod67.chatgpt.site'
  const codePattern = /^(?:[a-z0-9]+(?:-[a-z0-9]+)*-)?BY[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{12}$/
  const cacheKey = 'by-wishlist-share-links-v1'
  const memoryCache = new Map()
  const shortUrl = code => {
    if (!codePattern.test(code)) throw new Error('Invalid share code')
    const url = new URL('/w', location.origin)
    url.searchParams.set('l', code)
    return previewUrl(url.href)
  }
  const requestJson = async (path, options = {}) => {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 15000)
    try {
      const response = await fetch(shareApi + path, { credentials: 'omit', cache: 'no-store', ...options, signal: controller.signal })
      const data = await response.json()
      if (!response.ok || data.ok !== true) throw new Error('Wishlist sharing unavailable')
      return data
    } finally { clearTimeout(timeout) }
  }
  const createShortLink = async (handles, name = '', listKey = '') => {
    const items = [...new Set(handles)].filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle))
    if (!items.length || items.length > 100) throw new Error('Invalid wishlist')
    name = String(name).trim().replace(/\s+/g, ' ').slice(0, 60)
    if (/[@<>\u0000-\u001f]/.test(name)) name = ''
    const signature = JSON.stringify({ items, name, listKey })
    let cache = []
    try { cache = JSON.parse(localStorage.getItem(cacheKey) || '[]') } catch (_) {}
    if (!Array.isArray(cache)) cache = []
    const cached = memoryCache.get(signature) || cache.find(item => item.signature === signature)
    if (cached?.code && codePattern.test(cached.code)) return shortUrl(cached.code)
    const requestId = cached?.requestId || Array.from(crypto.getRandomValues(new Uint8Array(20)), value => value.toString(16).padStart(2, '0')).join('')
    const entry = { signature, requestId }
    const saveEntry = value => {
      memoryCache.set(signature, value)
      cache = [value, ...cache.filter(item => item.signature !== signature)].slice(0, 40)
      try { localStorage.setItem(cacheKey, JSON.stringify(cache)) } catch (_) {}
    }
    saveEntry(entry)
    const body = JSON.stringify({ items, name, requestId })
    const grant = await requestJson('/api/grant', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body })
    const saved = await requestJson('/api/shares', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-By-Share-Grant': grant.grant }, body })
    if (!codePattern.test(saved.code)) throw new Error('Invalid share code')
    saveEntry({ ...entry, code: saved.code })
    return shortUrl(saved.code)
  }
  window.BYWishlistLinks = { create: createShortLink, urlFor: shortUrl }
  const shortCode = new URLSearchParams(location.search).get('l')
  const shared = configNode && (new URLSearchParams(location.hash.slice(1)).has('by-wishlist') || shortCode !== null)
  if (shared) {
    document.querySelector('[data-by-legacy-wishlist]')?.removeAttribute('hidden')
    document.querySelector('[data-by-app-wishlist]')?.setAttribute('hidden', '')
    const launch = () => {
      configNode.textContent = JSON.stringify(config)
      const script = document.createElement('script')
      script.src = config.legacy_script
      document.body.appendChild(script)
    }
    if (shortCode !== null) {
      config.short_code = shortCode
      config.short_items = []
      config.short_error = true
      if (!codePattern.test(shortCode)) launch()
      else requestJson('/api/shares/' + encodeURIComponent(shortCode)).then(data => {
        if (data.v !== 1 || !Array.isArray(data.items) || !data.items.every(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle))) throw new Error('Invalid shared wishlist')
        config.short_items = data.items
        config.short_error = false
        config.short_url = shortUrl(shortCode)
      }).catch(() => {
        const status = document.querySelector('[data-by-wishlist-status]')
        if (status) status.textContent = config.strings?.load_error_detail || ''
      }).finally(launch)
    } else launch()
    return
  }

  const shareField = document.querySelector('[data-by-xb-share-field]')
  const shareInput = document.querySelector('[data-by-xb-share-link]')
  const shareStatus = document.querySelector('[data-by-xb-share-status]')
  const shareCopy = document.querySelector('[data-by-xb-share-copy]')
  const emailFields = document.querySelector('[data-by-wishlist-email-fields]')
  const senderInput = document.querySelector('[data-by-wishlist-sender]')
  const emailOpen = document.querySelector('[data-by-wishlist-email-open]')
  emailOpen?.addEventListener('click', () => {
    if (!shareInput?.value || (senderInput && !senderInput.reportValidity())) return
    const name = (senderInput?.value || '').trim().replace(/\s+/g, ' ')
    const subject = (name ? config.strings?.email_subject_named : config.strings?.email_subject) || config.strings?.share_title || ''
    const body = (config.strings?.email_body || '__LINK__').replaceAll('__SENDER__', name).replaceAll('__LINK__', shareInput.value).replace(/\n{3,}/g, '\n\n').trim()
    location.href = 'mailto:?subject=' + encodeURIComponent(subject.replaceAll('__SENDER__', name)) + '&body=' + encodeURIComponent(body)
  })
  const readXBList = key => {
    let value = localStorage.getItem(key) || '[]'
    if (value.startsWith('___xb___:')) {
      const bytes = Uint8Array.from(atob(value.slice(9)), character => character.charCodeAt(0))
      value = new TextDecoder().decode(bytes)
    }
    const list = JSON.parse(value)
    return Array.isArray(list) ? list : []
  }
  const copyShareLink = async () => {
    if (!shareInput?.value) return
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Copy unavailable')
      await navigator.clipboard.writeText(shareInput.value)
      if (shareStatus) shareStatus.textContent = config.strings?.copied || ''
    } catch (_) {
      shareInput.focus()
      shareInput.select()
      let copied = false
      try { copied = document.execCommand('copy') } catch (_) {}
      if (shareStatus) shareStatus.textContent = copied ? config.strings?.copied || '' : config.strings?.copy_manual || ''
    }
  }
  shareCopy?.addEventListener('click', copyShareLink)
  let sharing = false
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('.by-xb-wishlist-page .xb-wishlist-products__share-item')
    if (!button || !shareInput || !shareField) return
    event.preventDefault()
    event.stopImmediatePropagation()
    if (sharing) return
    sharing = true
    button.setAttribute('aria-busy', 'true')
    shareInput.value = ''
    shareField.hidden = false
    if (shareCopy) shareCopy.disabled = true
    const label = button.getAttribute('aria-label') || ''
    const action = button.getAttribute('data-by-share-action') || (/Copy Link$/i.test(label) ? 'copy' : /Email$/i.test(label) ? 'email' : /Facebook$/i.test(label) ? 'facebook' : /Twitter$/i.test(label) ? 'twitter' : /WhatsApp$/i.test(label) ? 'whatsapp' : '')
    if (emailFields) emailFields.hidden = action !== 'email'
    if (emailOpen) emailOpen.disabled = true
    const popup = ['facebook', 'twitter', 'whatsapp'].includes(action) ? window.open('about:blank', '_blank') : null
    if (popup) popup.opener = null
    try {
      if (shareStatus) shareStatus.textContent = document.querySelector('[data-by-wishlist-loading]')?.textContent || ''
      const titleNode = document.querySelector('.by-xb-wishlist-page .xb-wishlist-grid__detail-title')
      const title = titleNode?.getAttribute('data-by-original-label') || titleNode?.textContent.trim()
      const lists = readXBList('xb_multi_wishlists')
      const matches = lists.filter(list => !list.isDefault && list.name === title)
      if (matches.length > 1) throw new Error('Ambiguous wishlist')
      const current = matches[0]
      const key = current ? 'xb_wishlist_' + current._id : 'xb_wishlist_data'
      const items = readXBList(key)
      const handles = [...new Set(items.map(item => item.handle).filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle)))]
      if (!handles.length) {
        if (shareStatus) shareStatus.textContent = config.strings?.empty_share || ''
        popup?.close()
        return
      }
      const value = await createShortLink(handles, current?.name || '', current?._id || 'default')
      shareInput.value = value
      if (shareCopy) shareCopy.disabled = false
      if (shareStatus) shareStatus.textContent = ''
      const message = [config.strings?.email_message || config.strings?.share_description || '', value].filter(Boolean).join('\n\n')
      if (action === 'copy') await copyShareLink()
      else if (action === 'email') {
        if (emailOpen) emailOpen.disabled = false
        senderInput?.focus()
      }
      else if (action === 'facebook') {
        const target = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(value)
        if (popup) popup.location.href = target
        else window.open(target, '_blank', 'noopener')
      } else if (action === 'twitter') {
        const target = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(value) + '&text=' + encodeURIComponent(config.strings?.email_message || '')
        if (popup) popup.location.href = target
        else window.open(target, '_blank', 'noopener')
      } else if (action === 'whatsapp') {
        const target = 'https://wa.me/?text=' + encodeURIComponent(message)
        if (popup) popup.location.href = target
        else window.open(target, '_blank', 'noopener')
      } else if (navigator.share) await navigator.share({ title: config.strings?.share_title || '', text: config.strings?.email_message || '', url: value }).catch(() => {})
      else await copyShareLink()
    } catch (_) {
      popup?.close()
      if (shareStatus) shareStatus.textContent = config.strings?.load_error_detail || ''
    } finally {
      sharing = false
      button.removeAttribute('aria-busy')
    }
  }, true)
})()
